module.exports = __webpack_public_path__ + "static/media/ic_checked.7d7935d8.svg";